import { getCookie } from '~/composables/useCookieManager';
import { useClientsStore } from '~/stores/clients.ts';
import { useGtag } from '#imports';

export default defineNuxtPlugin(() => {
  const router = useRouter();
  const clientsStore = useClientsStore();
  const auth = useAuth();
  const colorMode = useColorMode();
  const runtimeConfig = useRuntimeConfig();
  const { gtag } = useGtag();

  router.beforeEach(async () => {
    colorMode.preference = 'light';

    if (auth.loggedIn) {
      // useAuth() loads the user lazily (the old @nuxt-alt/auth module loaded it at init),
      // so ensure it's loaded before reading clients — otherwise the missing-client check
      // below would fire on a fresh load before the user has been fetched.
      if (!auth.user) {
        await useUserStore().me();
      }

      // Handle missing clients scenario
      if (!clientsStore.clients || clientsStore.clients.length === 0) {
        window.location = `${runtimeConfig.public.accountsUrl}?message=missing_client`;
        return false;
      }

      // Bootstrap the active client on first navigation only. We deliberately
      // do NOT re-sync from the cookie on subsequent navigations: the cookie
      // is shared across tabs/windows, and silently overriding the in-memory
      // selection from it caused the active client to flip mid-session.
      if (!clientsStore.selectedClientId) {
        const cookieClientId = getCookie('selected_client_id', false);
        const cookieMatchesKnownClient = clientsStore.clients.some(
          c => String(c.id) === cookieClientId
        );
        const clientId = cookieMatchesKnownClient
          ? cookieClientId
          : String(clientsStore.clients[0].id);
        await clientsStore.setSelectedClient(clientId);
      }
    }

    gtag('set', 'user_properties', {
      portal_client_id: clientsStore.selectedClientId,
      portal_client_name: clientsStore.selectedClient?.name,
    });

    gtag('set', {
      user_id: auth.user?.id,
    });

    return true;
  });
});
